// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"styles_mainContainer__27KZb","mainContainerContent":"styles_mainContainerContent__1gnfh"};